/**
 * The illustrative equity/bond/cash split by spending runway that the
 * Time-Horizon rebalancing strategy targets. A fixed reference table (the engine
 * derives real allocations from each wrapper's runway and the user's funds) —
 * shared by the wizard's Strategy step and the results-page rebalancing panel so
 * there is a single source for these numbers.
 */

import './TimeHorizonAllocationTable.css';

interface RunwayRow {
  runway: string;
  equity: string;
  bond: string;
  cash: string;
}

const RUNWAY_ROWS: RunwayRow[] = [
  { runway: '0-1 yrs', equity: '0%', bond: '0%', cash: '100%' },
  { runway: '2 yrs', equity: '20%', bond: '40%', cash: '40%' },
  { runway: '3 yrs', equity: '30%', bond: '50%', cash: '20%' },
  { runway: '4 yrs', equity: '40%', bond: '60%', cash: '0%' },
  { runway: '5 yrs', equity: '50%', bond: '50%', cash: '0%' },
  { runway: '6 yrs', equity: '60%', bond: '40%', cash: '0%' },
  { runway: '7 yrs', equity: '70%', bond: '30%', cash: '0%' },
  { runway: '8 yrs', equity: '80%', bond: '20%', cash: '0%' },
  { runway: '9 yrs', equity: '90%', bond: '10%', cash: '0%' },
  { runway: '10+ yrs', equity: '100%', bond: '0%', cash: '0%' },
];

export function TimeHorizonAllocationTable() {
  return (
    <table className="time-horizon-allocation-table">
      <caption className="sr-only">Time-horizon allocation by spending runway</caption>
      <thead>
        <tr>
          <th>Spending runway</th>
          <th>Equity</th>
          <th>Bonds</th>
          <th>Cash</th>
        </tr>
      </thead>
      <tbody>
        {RUNWAY_ROWS.map(r => (
          <tr key={r.runway}>
            <td>{r.runway}</td>
            <td>{r.equity}</td>
            <td>{r.bond}</td>
            <td>{r.cash}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
